import carrierEditComponent from './carrier.edit.component';

let carrierEditModule = angular.module('carrieredit', [
  ])

  .component('carrieredit', carrierEditComponent)

  .name;

export default carrierEditModule;


// WEBPACK FOOTER //
// ./client/app/components/carrier/edit/index.js